import { RessourceTypes } from '@/framework/ressource/classes/Ressource';
import { Ressources, MapRessource } from '@/framework/base/helpers/Ressources';

export function RessourceGenControl(value: GenControl): MapRessource {
  return Ressources.newGet(RessourceTypes.CONTROL, GenControl[value]);
}
export enum GenControl {
  MANUAL_BILLING_DOCUMENT_DOCUMENT_REFERENCE,
  ETABLISSEMENT_MODE_FACTURE,
  ETABLISSEMENT_USER_DISABLED,
  ETABLISSEMENT_ACCORD_COLLECTIF,
  ETABLISSEMENT_PAYMENT_AUTO_SALAIRE,
  ETABLISSEMENT_LOGO,
  ETABLISSEMENT_STATUT_LICENCE_SPECTACLE,
  ETABLISSEMENT_LICENCE_VALIDITE,
  ETABLISSEMENT_LICENCE_SPECTACLE,
  FRACTION_DSN_ENTITE,
  CONTRAT_TEMPLATE_CONFIG_ETABLISSEMENT_SELECT,
  CHECK_RECEIVED_ETABLISSEMENT_SELECT,
  ETABLISSEMENT_RETRAITE_COMPLEMENTAIRE_NOM,
  ETABLISSEMENT_FCAP,
  AUTHORIZED_CREDIT_ETABLISSEMENT_SELECT,
  ETABLISSEMENT_FNAS,
  ETABLISSEMENT_POLE_EMPLOI_IDENTIFIANT,
  ETABLISSEMENT_POLE_EMPLOI_ADHESION,
  ETABLISSEMENT_POLE_EMPLOI_AFFILIATION,
  ETABLISSEMENT_LICENCE_STATUS,
  FRACTION_DSN_TYPE,
  FRACTION_DSN_GENRE,
  FRACTION_DSN_NOM,
  ETABLISSEMENT_IDENTITE_CONVENTION_BRANCHE_LIST,
  ETABLISSEMENT_IDENTITE_TRANCHE_EFFECTIF_SELECT,
  MANUAL_BILLING_DOCUMENT_AMOUNT_HT,
  ETABLISSEMENT_CONTACTS_CONTACT_SUMMARY,
  MANUAL_BILLING_DOCUMENT_LABEL,
  MANUAL_BILLING_DOCUMENT_REFERENCE,
  ETABLISSEMENT_CAISSES_CAISSE_SELECT_COMPLEMENTAIRE,
  APPRENTI_DATE_FIN,
  MANUAL_BILLING_DOCUMENT_EFFECTIVE_AT,
  MANUAL_BILLING_DOCUMENT_LEDGER_CODE,
  MANUAL_BILLING_DOCUMENT_IN_CART,
  MANUAL_BILLING_DOCUMENT_KIND,
  LIEU_LABEL,
  PRELEV_MEANS_RIB_SUMMARY,
  FRACTION_DSN_FRACTION,
  SALAIRE_MEANS_PAYMENT_MEANS_SUMMARY,
  FRACTION_DSN_NUMERO,
  FRACTION_DSN_MAIL,
  FRACTION_DSN_PRENOM,
  ETABLISSEMENT_CONGES_SPEC,
  ETABLISSEMENT_IDENTITE_BRANCHE_SELECT,
  ETABLISSEMENT_URSSAF,
  ETABLISSEMENT_VILLE,
  ETABLISSEMENT_SIRET,
  ETABLISSEMENT_NOM,
  ETABLISSEMENT_ALIAS,
  CRENEAU_HEURE_FIN,
  CRENEAU_HEURE_DEBUT,
  CRENEAU_DATE,
  CONTRAT_TEMPLATE_ACTIVE,
  CONTRAT_TEMPLATE_USE_CONVENTION,
  ETABLISSEMENT_BRANCHE_CODE,
  CONTRAT_TEMPLATE_TITRE,
  CONTRAT_EXO_ETRANGER,
  CONTRAT_EDIT_BASE_SALARIE,
  AUTHORIZED_CREDIT_CREDIT_LIMIT_UNTIL,
  AUTHORIZED_CREDIT_PERMANENT,
  AUTHORIZED_CREDIT_CREDIT_LIMIT,
  ATTESTATION_MOTIF,
  ATTESTATION_STATUT,
  ATTESTATION_DATE_VALID,
  CONTRAT_TEMPLATE_NAME,
  ETABLISSEMENT_BRANCHE_NOM,
  DEMANDE_ATTESTATION_ATTESTATION_DEF_SELECT,
  DEMANDE_ATTESTATION_ETABLISSEMENT_SELECT,
  ETABLISSEMENT_MAIL,
  ETABLISSEMENT_COMMERCIAL_CONTACT_SELECT,
  ETABLISSEMENT_NUMERO,
  ETABLISSEMENT_INFORMATION_FORME_JURIDIQUE_SELECT,
  ETABLISSEMENT_INFORMATION_TRANCHE_EFFECTIF_SELECT,
  ETABLISSEMENT_DATE_CREATION,
  ETABLISSEMENT_IDENT_ASSOCIATION,
  ETABLISSEMENT_INFORMATION_JURIDIQUE_CONVENTION_BRANCHE_LIST,
  ETABLISSEMENT_INFORMATION_JURIDIQUE_BRANCHE_SELECT,
  ETABLISSEMENT_FORME_JURIDIQUE_LABEL,
  ETABLISSEMENT_AFFLIATION_CAISSE_SELECT_COMPLEMENTAIRE,
  ETABLISSEMENT_SOUMIS_TVA,
  ETABLISSEMENT_REPRESENTANT_CONTACT_SUMMARY,
  ETABLISSEMENT_TRANCHE_EFFECTIF_LABEL,
  ETABLISSEMENT_CONVENTION_NOM,
  APPRENTI_CIVILITE_SELECT,
  ETABLISSEMENT_CONVENTION_CODE,
  ETABLISSEMENT_T1790,
  ETABLISSEMENT_T3252,
  LIEU_ADRESSE_SUMMARY,
  ATTESTATION_DATE_DEMANDE,
  ETABLISSEMENT_IDENTITE_FORME_JURIDIQUE_SELECT,
  MANUAL_BILLING_DOCUMENT_AMOUNT_TVA,
  USER_PROFIL,
  USER_IDENTIFIANT,
  CONTACT_NUMERO,
  CONTACT_MAIL,
  CONTACT_NOM,
  CONTACT_PRENOM,
  ADRESSE_VILLE,
  ADRESSE_CODE_POSTAL,
  USER_CLIENT98,
  ADRESSE_ADRESSE2,
  SYNCHRO98_NUMERO,
  SYNCHRO98_MAIL,
  SYNCHRO98_NOM,
  CONTACT_CIVILITE_SELECT,
  CONTACT_QUALITE_SELECT,
  SYNCHRO98_PRENOM,
  ADRESSE_PAYS_SELECT,
  SYNCHRO98_DIALOG98,
  ADRESSE_ADRESSE1,
  SYNCHRO98_CLIENT98,
  USER_DIALOG98,
  USER_NOM,
  SUBSCRIPTION_SUBSCRIPTION_TYPE_SELECT,
  ACCIDENT_TRAVAIL_TYPE,
  ACCIDENT_TRAVAIL_CODE_RISQUE,
  ACCIDENT_TRAVAIL_TAUX_PATRONAL,
  ACCIDENT_TRAVAIL_DATE_EFFET,
  MANUAL_BILLING_DOCUMENT_ETABLISSEMENT_SELECT,
  ACCIDENT_TRAVAIL_SOURCE,
  APPRENTI_NOM,
  USER_PRENOM,
  APPRENTI_PRENOM,
  RIB_IBAN,
  TRANSACTION_AMOUNT,
  TRANSACTION_REFERENCE,
  DELIVERY_COUNT,
  DELIVERY_AMOUNT,
  DELIVERY_REFERENCE,
  USER_NUMERO,
  USER_MAIL,
  APPRENTI_DATE_DEBUT,
  MANUAL_BILLING_DOCUMENT_VAT_RATE,
  CONTRAT_SALARIE_EMPLOI_SELECT,
  CONTRAT_SALARIE_SALARIE_SUMMARY,
  SALARIE_STATUT_HANDICAP,
  SALARIE_CIVILITE_PAYS_SELECT,
  SALARIE_CIVILITE_PAYS_SELECT_NAT,
  SALARIE_FISCALITE_LABEL,
  SALARIE_FISCALITE,
  SALARIE_NUMERO_CONGE_SPEC,
  SALARIE_NUMERO_SECU,
  SALARIE_DEPARTEMENT_NAISSANCE,
  SALARIE_EMPLOI_SELECT,
  SALARIE_VILLE_NAISSANCE,
  SALARIE_DATE_NAISSANCE,
  SALARIE_PSEUDO,
  SALARIE_EMPLOI_NOM,
  PROJET_NOM,
  NUMERO_OBJET_LABEL,
  NUMERO_OBJET_CODE,
  MANUAL_BILLING_DOCUMENT_PAYMENT_METHOD,
  MANUAL_BILLING_DOCUMENT_AMOUNT_TTC,
  SALARIE_NOM_NAISSANCE,
  CONTRAT_SALARIE_CONVENTION_CLAUSE_MIROIR,
  SALARIE_CIVILITE_SELECT,
  SALARIE_DATE_HANDICAP,
  SYNCHRO98_PROFIL,
  CRENEAUX_ACTIVITE_SELECT,
  CRENEAUX_LIEU_SUMMARY,
  SYNCHRO98_IDENTIFIANT,
  REMUNERATION_RUBRIQUE_SELECT,
  SALARIE_NUMERO,
  SALARIE_MAIL,
  CONTRAT_CONTRAT_TEMPLATE_SELECT,
  SALARIE_STATUT_HANDICAP_LABEL,
  SALARIE_NOM,
  SALARIE_DIALOG98,
  PROJET_NUMERO_OBJET_SUMMARY,
  PROJET_ETABLISSEMENT_SUMMARY,
  SALARIE_CLIENT98,
  SALARIE_PROFIL,
  SALARIE_IDENTIFIANT,
  SALARIE_AVATAR,
  SALARIE_ABATTEMENT_LABEL,
  SALARIE_ABATTEMENT,
  SALARIE_PRENOM,
  APPRENTI_DATE_RUPTURE,
}

export function RessourceGenCustom(value: GenCustom): MapRessource {
  return Ressources.newGet(RessourceTypes.CUSTOM, GenCustom[value]);
}
export enum GenCustom {
  REMUNERATION_FRAIS_GESTION,
  REMUNERATION_BULLETIN,
  CONTRAT_SALARIE_ARTISTE,
  REMUNERATION_MODE_CALCUL_TOTAL,
  REMUNERATION_MODE_CALCUL_NET,
  REMUNERATION_MODE_CALCUL_BRUT,
  REMUNERATION_SYNTHESE_PAIE_INVALID,
  CONTRAT_SALARIE_NON_CADRE,
  CONTRAT_SALARIE_CADRE,
  CONTRAT_SALARIE_TECHNICIEN,
  CRENEAUX_AUCUN_CRENEAU,
}

export function RessourceGenFiche(value: GenFiche): MapRessource {
  return Ressources.newGet(RessourceTypes.FICHE, GenFiche[value]);
}
export enum GenFiche {
  FICHE_TRANSACTION_CAISSE,
  FICHE_OBJET_METIER,
  FICHE_ATTESTATION_COMPTE,
  FICHE_GESTION_AEM,
  FICHE_VERSEMENT_EMPLOYEUR,
  FICHE_TRANSACTION_ETABLISSEMENT,
  FICHE_TRANSACTION_SALARIE,
  FICHE_TEST_PAIES,
  FICHE_STAT_CLIENT,
  FICHE_ETABLISSEMENT_ABSTRACT,
  FICHE_PAIE_VIEWER,
  FICHE_CONTRAT_VIEWER,
  FICHE_DOCUMENT_VIEWER,
  FICHE_DOCUMENT_LIST,
  FICHE_RAPPROCHEMENT,
  FICHE_BANQUE,
  FICHE_VIREMENT_ETABLISSEMENT,
  FICHE_VIREMENT_SALARIE,
  FICHE_CREDIT_LIMITS,
  FICHE_VIREMENTS_EMIS,
  FICHE_VIREMENTS_RECU,
  FICHE_PRELEVEMENT_EMIS,
  FICHE_CHECKS_EMIS,
  FICHE_CHECKS_RECU,
  FICHE_MANUAL_BILLING_DOCUMENT,
  FICHE_MANUAL_BILLING_DOCUMENTS,
  FICHE_POINTAGES,
  FICHE_CART_ITEM_LIST,
  FICHE_SUBSCRIPTION,
  FICHE_ABONNEMENT_LIST,
  FICHE_ETABLISSEMENT,
  FICHE_SIMULATION,
  FICHE_NOTIFICATION,
  FICHE_CARTE_EMIS,
  FICHE_PROFIL,
  FICHE_ETABLISSEMENT_LIST,
  FICHE_PREFERENCE,
  FICHE_SALARIE,
  FICHE_SALARIE_ABSTRACT,
  FICHE_SALARIE_LIST,
  FICHE_PAIE,
  FICHE_PROJET,
  FICHE_CONTRAT,
  FICHE_PROJET_LIST,
  FICHE_PROJET_CONTRATS,
}

export function RessourceGenModule(value: GenModule): MapRessource {
  return Ressources.newGet(RessourceTypes.MODULE, GenModule[value]);
}
export enum GenModule {
  MODULE_NOTIFICATION,
  MODULE_PREFERENCE,
  MODULE_ETABLISSEMENT,
  MODULE_SALARIE,
  MODULE_PROJET,
  MODULE_SUPPORT,
  MODULE_DOCUMENT,
  MODULE_ABONNEMENT,
  MODULE_CART,
  MODULE_COMPTA,
  MODULE_PROFIL,
  MODULE_MARKETING,
}

export function RessourceGenSection(value: GenSection): MapRessource {
  return Ressources.newGet(RessourceTypes.SECTION, GenSection[value]);
}
export enum GenSection {
  AFFILIATION_PROCESS,
  REMUNERATION,
  CRENEAUX,
  CONTRAT_SALARIE,
  CONTRAT,
  ADRESSE,
  CONTACT,
  MODE_CONNEXION,
  NOTIFICATION,
  STAT_CLIENT,
  PROJET_LIST,
  DPAE,
  SALARIE_CIVILITE,
  PROJET,
  CONTRAT_LIST,
  SALARIE_LIST,
  SALARIE_IDENTITE_ABSTRACT,
  SALARIE_COORDONNEES_ABSTRACT,
  SALARIE_INFO_COMPLEMENTAIRES_ABSTRACT,
  SALARIE_ETAT_CIVIL_ABSTRACT,
  SALARIE_RIB_ABSTRACT,
  SALARIE,
  SALARIE_INFORMATIONS,
  SALARIE_FISCALITE,
  RIB,
  LIST_SIMU,
  PAIES,
  STAT_SIMU,
  CHECK_RECEIVED_LIST,
  CONTRAT_VIEWER,
  SUBSCRIPTION,
  CART_ITEM_LIST,
  POINTAGES,
  MANUAL_BILLING_DOCUMENT_LIST,
  MANUAL_BILLING_DOCUMENT,
  CHECK_WAITED_LIST,
  ETABLISSEMENT_LIST,
  CHECK_DELIVERY_LIST,
  CHECK_PROCESSING_LIST,
  CHECK_EMITED_LIST,
  CHECK_PAYED_LIST,
  PRELEVEMENT_DELIVERY_LIST,
  PRELEVEMENT_DELIVERY_DETAIL,
  CARTE_DELIVERY_LIST,
  CARTE_EMITTED_LIST,
  VIREMENT_WAITED_LIST,
  VIREMENT_RECEIVED_LIST,
  VIREMENT_DELIVERY_LIST,
  VIREMENT_DELIVERY_DETAIL,
  CREDIT_LIMIT_LIST,
  VIREMENT_SALARIE,
  VIREMENT_ETABLISSEMENT,
  BANK_LIST,
  BANK_DETAIL,
  RAPPROCHEMENT,
  DOCUMENT_LIST,
  DOCUMENT_VIEWER,
  PAIE_VIEWER,
  ETABLISSEMENT_IDENTITE_ABSTRACT,
  ETABLISSEMENT_LOGO,
  ETABLISSEMENT_REPRESENTANT_ABSTRACT,
  PAYMENT,
  MANDAT_VIEWER,
  CONTRAT_TEMPLATE_CONFIG,
  CHECK_RECEIVED,
  DELIVERY,
  AUTHORIZED_CREDIT,
  IMPORT_DOC,
  IMPORT_STATUS,
  EXTERN_URL,
  DIALOG,
  CONNEXION,
  LIEU,
  NUMERO_OBJET,
  ETABLISSEMENT_COMMERCIAL,
  ETABLISSEMENT_INFORMATION,
  ETABLISSEMENT_CONTACT,
  ETABLISSEMENT_INFORMATION_JURIDIQUE,
  ETABLISSEMENT_AFFLIATION,
  ETABLISSEMENT_REPRESENTANT,
  FRACTION_DSN,
  APPRENTI,
  ACCIDENT_TRAVAIL,
  ACCORD_COLLECTIF,
  DEMANDE_ATTESTATION,
  GROUPEMENT_FACTURE,
  CGU,
  USER,
  BILL_VIEWER,
  ETABLISSEMENT_ADRESSE_ABSTRACT,
  OBJET_METIER_LIST,
  GESTION_AEM,
  ETABLISSEMENT_GESTIONNAIRES_ABSTRACT,
  ETABLISSEMENT_JURIDIQUE_ABSTRACT,
  DEMANDE_ATTESTATION_ABSTRACT,
  ETABLISSEMENT_ACCIDENT_TRAVAIL_ABSTRACT,
  ETABLISSEMENT_DOCUMENT_ABSTRACT,
  ETABLISSEMENT_PAYMENT_ABSTRACT,
  ABONNEMENT,
  ETABLISSEMENT_CART_ABSTRACT,
  ETABLISSEMENT_APPRENTI_ABSTRACT,
  ETABLISSEMENT_IDENTITE,
  ETABLISSEMENT_CONTACTS,
  ETABLISSEMENT_AFFILIATIONS,
  ETABLISSEMENT_CAISSES,
  DEMANDE_ATTESTATION_LIST,
  ACCIDENT_TRAVAIL_LIST,
  GESTIONNAIRES_PAIE,
  APPRENTI_LIST,
  PAYMENT_MEANS_LIST,
  PRELEV_MEANS,
  SALAIRE_MEANS,
  REGLEMENT_LIST,
  ETABLISSEMENT_DOCUMENT_LIST,
  PARAMETRES_PAIE,
  TRANSACTION_CAISSE,
  TRANSACTION_SALARIE,
  TRANSACTION_ETABLISSEMENT,
  VERSEMENT_EMPLOYEUR,
  ATTESTATION_COMPTE,
  ABONNEMENT_LIST,
}

export const generatedRessources = [
  { type: RessourceTypes.CUSTOM, name: GenCustom[GenCustom.CONTRAT_SALARIE_ARTISTE], label: 'artiste', placeholder: '' },
  { type: RessourceTypes.CUSTOM, name: GenCustom[GenCustom.CONTRAT_SALARIE_TECHNICIEN], label: 'technicien', placeholder: '' },
  { type: RessourceTypes.CUSTOM, name: GenCustom[GenCustom.CONTRAT_SALARIE_CADRE], label: 'cadre', placeholder: '' },
  { type: RessourceTypes.CUSTOM, name: GenCustom[GenCustom.CONTRAT_SALARIE_NON_CADRE], label: 'non cadre', placeholder: '' },

  { type: RessourceTypes.CUSTOM, name: GenCustom[GenCustom.CRENEAUX_AUCUN_CRENEAU], label: 'aucun créneau', placeholder: '' },

  { type: RessourceTypes.CUSTOM, name: GenCustom[GenCustom.REMUNERATION_MODE_CALCUL_BRUT], label: 'brut', placeholder: '' },
  { type: RessourceTypes.CUSTOM, name: GenCustom[GenCustom.REMUNERATION_MODE_CALCUL_NET], label: 'net', placeholder: '' },
  { type: RessourceTypes.CUSTOM, name: GenCustom[GenCustom.REMUNERATION_MODE_CALCUL_TOTAL], label: 'employeur', placeholder: '' },
  { type: RessourceTypes.CUSTOM, name: GenCustom[GenCustom.REMUNERATION_SYNTHESE_PAIE_INVALID], label: 'calculer', placeholder: '' },
  { type: RessourceTypes.CUSTOM, name: GenCustom[GenCustom.REMUNERATION_FRAIS_GESTION], label: 'Frais de gestion', placeholder: '' },
  { type: RessourceTypes.CUSTOM, name: GenCustom[GenCustom.REMUNERATION_BULLETIN], label: 'bulletins', placeholder: '' },


  { type: RessourceTypes.SECTION, name: GenSection[GenSection.ABONNEMENT_LIST], label: 'Abonnements(s)', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.SUBSCRIPTION_SUBSCRIPTION_TYPE_SELECT], label: 'Choix d\'une offre\'', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.SUBSCRIPTION], label: 'Abonnements', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.CART_ITEM_LIST], label: 'Mon panier', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.POINTAGES], label: 'Pointages', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.MANUAL_BILLING_DOCUMENT_LIST], label: 'Factures et avoirs manuels', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.MANUAL_BILLING_DOCUMENT_ETABLISSEMENT_SELECT], label: 'Établissement', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.MANUAL_BILLING_DOCUMENT], label: 'Facture ou avoir manuel', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.CHECK_WAITED_LIST], label: 'Chèques attendus', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.CHECK_RECEIVED_LIST], label: 'Chèques reçus', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.CHECK_DELIVERY_LIST], label: 'Bordereaux de remise', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.CHECK_PROCESSING_LIST], label: 'Chèques a émettre', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.CHECK_EMITED_LIST], label: 'Chèques émis', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.CHECK_PAYED_LIST], label: 'Chèques émis encaissés', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.PRELEVEMENT_DELIVERY_LIST], label: 'Fichiers de prélèvements', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.PRELEVEMENT_DELIVERY_DETAIL], label: 'Détail du fichier de prélèvement', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.CARTE_DELIVERY_LIST], label: 'Relevés cartes bancaires', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.CARTE_EMITTED_LIST], label: 'Détail du relevé', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.VIREMENT_WAITED_LIST], label: 'Virements attendus', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.VIREMENT_RECEIVED_LIST], label: 'Virements reçus', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.VIREMENT_DELIVERY_LIST], label: 'Fichiers de virements', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.VIREMENT_DELIVERY_DETAIL], label: 'Détail du fichier de virements', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.CREDIT_LIMIT_LIST], label: 'Encours autorisés', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.VIREMENT_SALARIE], label: 'Paiement des salariés', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.VIREMENT_ETABLISSEMENT], label: 'Remboursement des établissements', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.BANK_LIST], label: 'Ecritures par jour', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.BANK_DETAIL], label: 'Détail quotidien', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.RAPPROCHEMENT], label: 'Rapprochements manuels', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.DOCUMENT_LIST], label: 'Document(s)', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.DOCUMENT_VIEWER], label: 'Document', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.CONTRAT_VIEWER], label: 'Contrat de travail', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.PAIE_VIEWER], label: 'Fiche de paie', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.STAT_SIMU], label: 'Statistiques des simulations', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.LIST_SIMU], label: 'Liste des simulations', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.STAT_CLIENT], label: 'Liste Client', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.NOTIFICATION], label: 'Liste notifications', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.MODE_CONNEXION], label: 'Mes préférences', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.CONTACT_CIVILITE_SELECT], label: 'Civilité', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.CONTACT_QUALITE_SELECT], label: 'Qualité', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.CONTACT], label: 'Contact', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.ADRESSE_PAYS_SELECT], label: 'Pays', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.ADRESSE], label: 'Adresse', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.PROJET_LIST], label: 'Projets de paie', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.CONTRAT_SALARIE_EMPLOI_SELECT], label: 'Emploi', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.CONTRAT_SALARIE_CONVENTION_CLAUSE_MIROIR], label: 'Convention clause miroir', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.CONTRAT_SALARIE_SALARIE_SUMMARY], label: 'Salarié', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.CONTRAT_SALARIE], label: 'Salarié', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.CRENEAUX_ACTIVITE_SELECT], label: 'Activité', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.CRENEAUX_LIEU_SUMMARY], label: 'Lieu de prestation', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.CRENEAUX], label: 'Créneaux', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.REMUNERATION_RUBRIQUE_SELECT], label: 'Rubrique', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.REMUNERATION], label: 'Rémunération', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.AFFILIATION_PROCESS], label: 'Affiliation France Travail', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.CONTRAT_CONTRAT_TEMPLATE_SELECT], label: 'Modèle de contrat', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.CONTRAT], label: 'Contrat de travail', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.DPAE], label: 'Déclaration préalable à l\'embauche', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.PAIES], label: 'Bulletin de paie', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.PROJET_NUMERO_OBJET_SUMMARY], label: 'Numéro d\'objet', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.PROJET_ETABLISSEMENT_SUMMARY], label: 'Établissement', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.PROJET], label: 'PROJET', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.CONTRAT_LIST], label: 'Contrat(s)', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.SALARIE_LIST], label: 'Salariés', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.SALARIE_IDENTITE_ABSTRACT], label: '', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.SALARIE_COORDONNEES_ABSTRACT], label: 'Coordonnées', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.SALARIE_INFO_COMPLEMENTAIRES_ABSTRACT], label: '', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.SALARIE_ETAT_CIVIL_ABSTRACT], label: '', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.SALARIE_RIB_ABSTRACT], label: '', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.SALARIE_CIVILITE_SELECT], label: 'Civilité', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.SALARIE_EMPLOI_SELECT], label: 'Métier', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.SALARIE], label: 'Salarié', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.SALARIE_CIVILITE_PAYS_SELECT], label: 'Pays de naissance', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.SALARIE_CIVILITE_PAYS_SELECT_NAT], label: 'Nationalité', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.SALARIE_CIVILITE], label: 'Etat civil', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.SALARIE_INFORMATIONS], label: 'Informations complémentaires', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.SALARIE_FISCALITE], label: 'Fiscalité', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.RIB], label: 'Compte bancaire', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.ETABLISSEMENT_LIST], label: 'Etablissement(s)', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.ETABLISSEMENT_IDENTITE_ABSTRACT], label: '', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.ETABLISSEMENT_ADRESSE_ABSTRACT], label: '', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.ETABLISSEMENT_REPRESENTANT_ABSTRACT], label: 'Contacts', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.ETABLISSEMENT_GESTIONNAIRES_ABSTRACT], label: '', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.ETABLISSEMENT_JURIDIQUE_ABSTRACT], label: 'Informations juridiques et affiliations', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.DEMANDE_ATTESTATION_ABSTRACT], label: 'Attestations de comptes à jour', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.ETABLISSEMENT_ACCIDENT_TRAVAIL_ABSTRACT], label: 'Données sociales', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.ETABLISSEMENT_DOCUMENT_ABSTRACT], label: 'Documents', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.ETABLISSEMENT_PAYMENT_ABSTRACT], label: 'Coordonnées bancaires et règlements', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.ABONNEMENT], label: 'Abonnement et Factures', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.ETABLISSEMENT_CART_ABSTRACT], label: '', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.ETABLISSEMENT_APPRENTI_ABSTRACT], label: 'Apprentis', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.ETABLISSEMENT_IDENTITE_FORME_JURIDIQUE_SELECT], label: 'Forme juridique', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.ETABLISSEMENT_IDENTITE_BRANCHE_SELECT], label: 'Branche', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.ETABLISSEMENT_IDENTITE_CONVENTION_BRANCHE_LIST], label: 'Convention', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.ETABLISSEMENT_IDENTITE_TRANCHE_EFFECTIF_SELECT], label: 'Tranche effectif', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.ETABLISSEMENT_IDENTITE], label: 'Identité', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.ETABLISSEMENT_CONTACTS_CONTACT_SUMMARY], label: 'Représentant', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.ETABLISSEMENT_CONTACTS], label: 'Contact', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.ETABLISSEMENT_AFFILIATIONS], label: 'Affiliations collectées', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.ETABLISSEMENT_CAISSES_CAISSE_SELECT_COMPLEMENTAIRE], label: 'Retraite complémentaire', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.ETABLISSEMENT_CAISSES], label: 'Caisses et affiliations', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.DEMANDE_ATTESTATION_LIST], label: 'Attestations de comptes à jour', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.ACCIDENT_TRAVAIL_LIST], label: 'Taux accident du travail', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.GESTIONNAIRES_PAIE], label: 'Gestionnaires de paie', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.APPRENTI_LIST], label: 'Apprentis', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.PAYMENT_MEANS_LIST], label: 'Moyens de paiement', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.PRELEV_MEANS_RIB_SUMMARY], label: 'Moyen de paiement', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.PRELEV_MEANS], label: 'Prélèvements à la source', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.SALAIRE_MEANS_PAYMENT_MEANS_SUMMARY], label: 'Moyen de paiement', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.SALAIRE_MEANS], label: 'Règlement des salaires et frais', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.REGLEMENT_LIST], label: 'Prochaine facture', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.ETABLISSEMENT_LOGO], label: 'Logo de l\'établissement', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.ETABLISSEMENT_DOCUMENT_LIST], label: 'Documents', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.PARAMETRES_PAIE], label: 'Paramètres paies', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.TRANSACTION_CAISSE], label: 'Cotisations versées aux caisses sociales', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.TRANSACTION_SALARIE], label: 'Virements émis ou à émettre', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.TRANSACTION_ETABLISSEMENT], label: 'Remboursements des établissements', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.VERSEMENT_EMPLOYEUR], label: 'Règlements des employeurs', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.GESTION_AEM], label: 'Gestion des AEM', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.ATTESTATION_COMPTE], label: 'Attestations de compte à jour', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.OBJET_METIER_LIST], label: 'Reprises et échecs d\'API', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.BILL_VIEWER], label: 'PDF_VIEWER', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.PAYMENT], label: 'Modes de règlement', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.MANDAT_VIEWER], label: 'Document', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.CONTRAT_TEMPLATE_CONFIG_ETABLISSEMENT_SELECT], label: 'Établissement', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.CONTRAT_TEMPLATE_CONFIG], label: 'Configuration du modèle de contrat', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.CHECK_RECEIVED_ETABLISSEMENT_SELECT], label: 'Emetteur', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.CHECK_RECEIVED], label: 'remise de chèque', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.DELIVERY], label: 'Bordereau', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.AUTHORIZED_CREDIT_ETABLISSEMENT_SELECT], label: 'Établissement', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.AUTHORIZED_CREDIT], label: 'Encours autorisé', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.IMPORT_DOC], label: 'Import de documents', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.IMPORT_STATUS], label: 'Dialogue de téléchargement des statuts', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.EXTERN_URL], label: 'Ouvre une URL (url = attribut, si objId = 0 : même onglet, sinon autre onglet)', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.DIALOG], label: 'Affiche un dialogue pour saisir un texte', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.CONNEXION], label: 'Connexion', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.LIEU_ADRESSE_SUMMARY], label: 'Adresse', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.LIEU], label: 'Lieu', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.NUMERO_OBJET], label: 'Numéro d\'objet', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.ETABLISSEMENT_COMMERCIAL_CONTACT_SELECT], label: 'Commercial', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.ETABLISSEMENT_COMMERCIAL], label: 'Contact', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.ETABLISSEMENT_INFORMATION_FORME_JURIDIQUE_SELECT], label: 'Forme juridique', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.ETABLISSEMENT_INFORMATION_TRANCHE_EFFECTIF_SELECT], label: 'Tranche effectif', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.ETABLISSEMENT_INFORMATION], label: 'Identité', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.ETABLISSEMENT_CONTACT], label: 'Contact', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.ETABLISSEMENT_INFORMATION_JURIDIQUE_CONVENTION_BRANCHE_LIST], label: 'Convention', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.ETABLISSEMENT_INFORMATION_JURIDIQUE_BRANCHE_SELECT], label: 'Branche', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.ETABLISSEMENT_INFORMATION_JURIDIQUE], label: 'Informations juridiques', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.ETABLISSEMENT_AFFLIATION_CAISSE_SELECT_COMPLEMENTAIRE], label: 'Caisse de retraite complémentaire', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.ETABLISSEMENT_AFFLIATION], label: 'Affiliations', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.ETABLISSEMENT_REPRESENTANT_CONTACT_SUMMARY], label: 'Représentant légal', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.ETABLISSEMENT_REPRESENTANT], label: 'Contact', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.FRACTION_DSN], label: 'Gestionnaires de paie', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.APPRENTI_CIVILITE_SELECT], label: 'Civilité', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.APPRENTI], label: 'Apprenti', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.ACCIDENT_TRAVAIL], label: 'Taux accident du travail', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.ACCORD_COLLECTIF], label: 'Accord collectif', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.DEMANDE_ATTESTATION_ETABLISSEMENT_SELECT], label: 'Etablissement', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.DEMANDE_ATTESTATION_ATTESTATION_DEF_SELECT], label: 'Organisme', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.DEMANDE_ATTESTATION], label: 'Demande attestation', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.GROUPEMENT_FACTURE], label: 'Regroupement des factures', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.CGU], label: 'Cgu', placeholder: '' },
  { type: RessourceTypes.SECTION, name: GenSection[GenSection.USER], label: 'Utilisateur', placeholder: '' },
  { type: RessourceTypes.FICHE, name: GenFiche[GenFiche.FICHE_ABONNEMENT_LIST], label: '', placeholder: '' },
  { type: RessourceTypes.FICHE, name: GenFiche[GenFiche.FICHE_SUBSCRIPTION], label: '', placeholder: '' },
  { type: RessourceTypes.FICHE, name: GenFiche[GenFiche.FICHE_CART_ITEM_LIST], label: '', placeholder: '' },
  { type: RessourceTypes.FICHE, name: GenFiche[GenFiche.FICHE_POINTAGES], label: '', placeholder: '' },
  { type: RessourceTypes.FICHE, name: GenFiche[GenFiche.FICHE_MANUAL_BILLING_DOCUMENTS], label: 'Factures et avoirs manuels', placeholder: '' },
  { type: RessourceTypes.FICHE, name: GenFiche[GenFiche.FICHE_MANUAL_BILLING_DOCUMENT], label: 'Facture ou avoir manuel', placeholder: '' },
  { type: RessourceTypes.FICHE, name: GenFiche[GenFiche.FICHE_CHECKS_RECU], label: '', placeholder: '' },
  { type: RessourceTypes.FICHE, name: GenFiche[GenFiche.FICHE_CHECKS_EMIS], label: '', placeholder: '' },
  { type: RessourceTypes.FICHE, name: GenFiche[GenFiche.FICHE_PRELEVEMENT_EMIS], label: '', placeholder: '' },
  { type: RessourceTypes.FICHE, name: GenFiche[GenFiche.FICHE_CARTE_EMIS], label: '', placeholder: '' },
  { type: RessourceTypes.FICHE, name: GenFiche[GenFiche.FICHE_VIREMENTS_RECU], label: '', placeholder: '' },
  { type: RessourceTypes.FICHE, name: GenFiche[GenFiche.FICHE_VIREMENTS_EMIS], label: '', placeholder: '' },
  { type: RessourceTypes.FICHE, name: GenFiche[GenFiche.FICHE_CREDIT_LIMITS], label: 'Encours autorisés', placeholder: '' },
  { type: RessourceTypes.FICHE, name: GenFiche[GenFiche.FICHE_VIREMENT_SALARIE], label: '', placeholder: '' },
  { type: RessourceTypes.FICHE, name: GenFiche[GenFiche.FICHE_VIREMENT_ETABLISSEMENT], label: '', placeholder: '' },
  { type: RessourceTypes.FICHE, name: GenFiche[GenFiche.FICHE_BANQUE], label: '', placeholder: '' },
  { type: RessourceTypes.FICHE, name: GenFiche[GenFiche.FICHE_RAPPROCHEMENT], label: '', placeholder: '' },
  { type: RessourceTypes.FICHE, name: GenFiche[GenFiche.FICHE_DOCUMENT_LIST], label: '', placeholder: '' },
  { type: RessourceTypes.FICHE, name: GenFiche[GenFiche.FICHE_DOCUMENT_VIEWER], label: '', placeholder: '' },
  { type: RessourceTypes.FICHE, name: GenFiche[GenFiche.FICHE_CONTRAT_VIEWER], label: '', placeholder: '' },
  { type: RessourceTypes.FICHE, name: GenFiche[GenFiche.FICHE_PAIE_VIEWER], label: '', placeholder: '' },
  { type: RessourceTypes.FICHE, name: GenFiche[GenFiche.FICHE_SIMULATION], label: '', placeholder: '' },
  { type: RessourceTypes.FICHE, name: GenFiche[GenFiche.FICHE_STAT_CLIENT], label: '', placeholder: '' },
  { type: RessourceTypes.FICHE, name: GenFiche[GenFiche.FICHE_NOTIFICATION], label: '', placeholder: '' },
  { type: RessourceTypes.FICHE, name: GenFiche[GenFiche.FICHE_PREFERENCE], label: '', placeholder: '' },
  { type: RessourceTypes.FICHE, name: GenFiche[GenFiche.FICHE_PROFIL], label: '', placeholder: '' },
  { type: RessourceTypes.FICHE, name: GenFiche[GenFiche.FICHE_PROJET_LIST], label: 'Mes projets de paie', placeholder: '' },
  { type: RessourceTypes.FICHE, name: GenFiche[GenFiche.FICHE_PROJET_CONTRATS], label: 'Contrat', placeholder: '' },
  { type: RessourceTypes.FICHE, name: GenFiche[GenFiche.FICHE_PROJET], label: 'Projet de paie', placeholder: '' },
  { type: RessourceTypes.FICHE, name: GenFiche[GenFiche.FICHE_CONTRAT], label: '', placeholder: '' },
  { type: RessourceTypes.FICHE, name: GenFiche[GenFiche.FICHE_PAIE], label: '', placeholder: '' },
  { type: RessourceTypes.FICHE, name: GenFiche[GenFiche.FICHE_SALARIE_LIST], label: '', placeholder: '' },
  { type: RessourceTypes.FICHE, name: GenFiche[GenFiche.FICHE_SALARIE_ABSTRACT], label: '', placeholder: '' },
  { type: RessourceTypes.FICHE, name: GenFiche[GenFiche.FICHE_SALARIE], label: '', placeholder: '' },
  { type: RessourceTypes.FICHE, name: GenFiche[GenFiche.FICHE_ETABLISSEMENT_LIST], label: '', placeholder: '' },
  { type: RessourceTypes.FICHE, name: GenFiche[GenFiche.FICHE_ETABLISSEMENT_ABSTRACT], label: '', placeholder: '' },
  { type: RessourceTypes.FICHE, name: GenFiche[GenFiche.FICHE_ETABLISSEMENT], label: '', placeholder: '' },
  { type: RessourceTypes.FICHE, name: GenFiche[GenFiche.FICHE_TEST_PAIES], label: '', placeholder: '' },
  { type: RessourceTypes.FICHE, name: GenFiche[GenFiche.FICHE_TRANSACTION_CAISSE], label: '', placeholder: '' },
  { type: RessourceTypes.FICHE, name: GenFiche[GenFiche.FICHE_TRANSACTION_SALARIE], label: '', placeholder: '' },
  { type: RessourceTypes.FICHE, name: GenFiche[GenFiche.FICHE_TRANSACTION_ETABLISSEMENT], label: '', placeholder: '' },
  { type: RessourceTypes.FICHE, name: GenFiche[GenFiche.FICHE_VERSEMENT_EMPLOYEUR], label: '', placeholder: '' },
  { type: RessourceTypes.FICHE, name: GenFiche[GenFiche.FICHE_GESTION_AEM], label: '', placeholder: '' },
  { type: RessourceTypes.FICHE, name: GenFiche[GenFiche.FICHE_ATTESTATION_COMPTE], label: '', placeholder: '' },
  { type: RessourceTypes.FICHE, name: GenFiche[GenFiche.FICHE_OBJET_METIER], label: '', placeholder: '' },
  { type: RessourceTypes.MODULE, name: GenModule[GenModule.MODULE_ABONNEMENT], label: 'Abonnement', placeholder: '' },
  { type: RessourceTypes.MODULE, name: GenModule[GenModule.MODULE_CART], label: 'Mon panier', placeholder: '' },
  { type: RessourceTypes.MODULE, name: GenModule[GenModule.MODULE_COMPTA], label: 'Comptabilité', placeholder: '' },
  { type: RessourceTypes.MODULE, name: GenModule[GenModule.MODULE_DOCUMENT], label: 'Mes documents', placeholder: '' },
  { type: RessourceTypes.MODULE, name: GenModule[GenModule.MODULE_MARKETING], label: 'Marketing', placeholder: '' },
  { type: RessourceTypes.MODULE, name: GenModule[GenModule.MODULE_NOTIFICATION], label: 'Centre d\'actions', placeholder: '' },
  { type: RessourceTypes.MODULE, name: GenModule[GenModule.MODULE_PREFERENCE], label: 'Mes préférences', placeholder: '' },
  { type: RessourceTypes.MODULE, name: GenModule[GenModule.MODULE_PROFIL], label: 'Mon profil', placeholder: '' },
  { type: RessourceTypes.MODULE, name: GenModule[GenModule.MODULE_PROJET], label: '', placeholder: '' },
  { type: RessourceTypes.MODULE, name: GenModule[GenModule.MODULE_SALARIE], label: 'Mes salariés', placeholder: '' },
  { type: RessourceTypes.MODULE, name: GenModule[GenModule.MODULE_ETABLISSEMENT], label: 'Mes établissements', placeholder: '' },
  { type: RessourceTypes.MODULE, name: GenModule[GenModule.MODULE_SUPPORT], label: 'Support', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.ACCIDENT_TRAVAIL_TYPE], label: 'Type', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.ACCIDENT_TRAVAIL_CODE_RISQUE], label: 'Code risque', placeholder: 'Code risque' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.ACCIDENT_TRAVAIL_TAUX_PATRONAL], label: 'Taux patronal', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.ACCIDENT_TRAVAIL_DATE_EFFET], label: 'Date d\'effet', placeholder: 'jj/mm/aaaa' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.ACCIDENT_TRAVAIL_SOURCE], label: 'Source', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.APPRENTI_NOM], label: 'Nom', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.APPRENTI_PRENOM], label: 'Prenom', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.APPRENTI_DATE_DEBUT], label: 'Date de début', placeholder: 'jj/mm/aaaa' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.APPRENTI_DATE_FIN], label: 'Date de fin', placeholder: 'jj/mm/aaaa' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.APPRENTI_DATE_RUPTURE], label: 'Date de rupture', placeholder: 'jj/mm/aaaa' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.ATTESTATION_DATE_DEMANDE], label: 'Date de la demande', placeholder: 'jj/mm/aaaa' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.ATTESTATION_DATE_VALID], label: 'Date de validité', placeholder: 'jj/mm/aaaa' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.ATTESTATION_STATUT], label: 'Statut', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.ATTESTATION_MOTIF], label: 'Motif de refus', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.AUTHORIZED_CREDIT_CREDIT_LIMIT], label: 'Encours autorisé', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.AUTHORIZED_CREDIT_PERMANENT], label: 'Permanent', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.AUTHORIZED_CREDIT_CREDIT_LIMIT_UNTIL], label: 'Autorisé jusqu\'au', placeholder: 'jj/mm/aaaa' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.CONTRAT_EDIT_BASE_SALARIE], label: 'Base salarié', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.CONTRAT_EXO_ETRANGER], label: 'Je dispose du formulaire A1 et demande à être exonéré de cotisations', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.CONTRAT_TEMPLATE_NAME], label: 'Libellé', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.CONTRAT_TEMPLATE_TITRE], label: 'Titre', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.CONTRAT_TEMPLATE_USE_CONVENTION], label: 'Modèle conventionnel', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.CONTRAT_TEMPLATE_ACTIVE], label: 'Actif', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.CRENEAU_DATE], label: 'Date', placeholder: 'jj/mm/aaaa' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.CRENEAU_HEURE_DEBUT], label: 'Début', placeholder: 'HH:mm' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.CRENEAU_HEURE_FIN], label: 'Fin', placeholder: 'HH:mm' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.ETABLISSEMENT_ALIAS], label: 'Nom usuel', placeholder: 'Alias' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.ETABLISSEMENT_NOM], label: 'Nom', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.ETABLISSEMENT_SIRET], label: 'SIRET', placeholder: '453 700 023 00049' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.ETABLISSEMENT_BRANCHE_CODE], label: 'Code APE', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.ETABLISSEMENT_BRANCHE_NOM], label: 'Activité APE', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.ETABLISSEMENT_T3252], label: 'Type d\'activité', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.ETABLISSEMENT_T1790], label: 'Type de structure', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.ETABLISSEMENT_CONVENTION_CODE], label: 'IDCC', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.ETABLISSEMENT_CONVENTION_NOM], label: 'Convention collective', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.ETABLISSEMENT_TRANCHE_EFFECTIF_LABEL], label: 'Effectif', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.ETABLISSEMENT_SOUMIS_TVA], label: 'Assujetti à la TVA', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.ETABLISSEMENT_FORME_JURIDIQUE_LABEL], label: 'Forme juridique', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.ETABLISSEMENT_IDENT_ASSOCIATION], label: 'Code RNE', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.ETABLISSEMENT_DATE_CREATION], label: 'Date de création', placeholder: 'jj/mm/aaaa' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.ETABLISSEMENT_NUMERO], label: 'Téléphone de l\'établissement', placeholder: '01 00 00 00 00' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.ETABLISSEMENT_MAIL], label: 'Adresse mail de l\'établissement', placeholder: 'E-mail' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.ETABLISSEMENT_VILLE], label: 'Ville', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.ETABLISSEMENT_URSSAF], label: 'Numéro URSSAF', placeholder: '117 222 333 444 555' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.ETABLISSEMENT_CONGES_SPEC], label: 'Numéro Congés Spectacle', placeholder: 'N° Congé Spectacle' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.ETABLISSEMENT_POLE_EMPLOI_AFFILIATION], label: 'N° Affiliation France Travail', placeholder: '080 12345678 1' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.ETABLISSEMENT_POLE_EMPLOI_ADHESION], label: 'N° de déclaration sociale France Travail', placeholder: 'CS12345678' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.ETABLISSEMENT_POLE_EMPLOI_IDENTIFIANT], label: 'N° d\'identifiant Espace Employeur France Travail', placeholder: 'N° d\'identifiant' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.ETABLISSEMENT_FNAS], label: 'N° d\'affiliation FNAS', placeholder: 'AB12' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.ETABLISSEMENT_FCAP], label: 'N° d\'affiliation FCAP', placeholder: 'N° FCAP' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.ETABLISSEMENT_RETRAITE_COMPLEMENTAIRE_NOM], label: 'Caisse de retraite complémentaire', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.ETABLISSEMENT_LICENCE_STATUS], label: 'Statut de la licence', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.ETABLISSEMENT_LICENCE_SPECTACLE], label: 'Licence d\'entrepreneur de spectacles vivants', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.ETABLISSEMENT_LICENCE_VALIDITE], label: 'Date d\'expiration de la licence', placeholder: 'jj/mm/aaaa' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.ETABLISSEMENT_STATUT_LICENCE_SPECTACLE], label: 'Licence d’entrepreneur de spectacles vivants', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.ETABLISSEMENT_LOGO], label: 'Image', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.ETABLISSEMENT_PAYMENT_AUTO_SALAIRE], label: 'payment automatique', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.ETABLISSEMENT_ACCORD_COLLECTIF], label: 'J\'ai conclu un accord collectif pour la DFS', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.ETABLISSEMENT_USER_DISABLED], label: 'Compte désactivé', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.ETABLISSEMENT_MODE_FACTURE], label: 'Regroupement des factures', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.FRACTION_DSN_ENTITE], label: 'Raison sociale', placeholder: 'Raison sociale' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.FRACTION_DSN_TYPE], label: 'Type', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.FRACTION_DSN_GENRE], label: 'Genre', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.FRACTION_DSN_NOM], label: 'Nom', placeholder: 'Nom' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.FRACTION_DSN_PRENOM], label: 'Prénom', placeholder: 'Prénom' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.FRACTION_DSN_MAIL], label: 'Adresse mail', placeholder: 'E-mail' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.FRACTION_DSN_NUMERO], label: 'Téléphone', placeholder: '01 00 00 00 00' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.FRACTION_DSN_FRACTION], label: 'Fraction DSN', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.LIEU_LABEL], label: 'Libellé', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.MANUAL_BILLING_DOCUMENT_KIND], label: 'Nature', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.MANUAL_BILLING_DOCUMENT_IN_CART], label: 'Prendre en compte dans le panier', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.MANUAL_BILLING_DOCUMENT_LEDGER_CODE], label: 'Type comptable', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.MANUAL_BILLING_DOCUMENT_EFFECTIVE_AT], label: 'Date du document', placeholder: 'jj/mm/aaaa' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.MANUAL_BILLING_DOCUMENT_DOCUMENT_REFERENCE], label: 'Pièce comptable', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.MANUAL_BILLING_DOCUMENT_REFERENCE], label: 'Référence', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.MANUAL_BILLING_DOCUMENT_LABEL], label: 'Libellé', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.MANUAL_BILLING_DOCUMENT_AMOUNT_HT], label: 'Montant HT', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.MANUAL_BILLING_DOCUMENT_VAT_RATE], label: 'Taux de TVA (%)', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.MANUAL_BILLING_DOCUMENT_AMOUNT_TVA], label: 'Montant TVA', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.MANUAL_BILLING_DOCUMENT_AMOUNT_TTC], label: 'Montant TTC', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.MANUAL_BILLING_DOCUMENT_PAYMENT_METHOD], label: 'Mode de règlement', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.NUMERO_OBJET_CODE], label: 'Numéro', placeholder: '23 AZ 763430 19' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.NUMERO_OBJET_LABEL], label: 'libellé', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.PROJET_NOM], label: 'Nom du projet', placeholder: 'Nom' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.SALARIE_EMPLOI_NOM], label: 'Métier', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.SALARIE_PSEUDO], label: 'Pseudo', placeholder: 'Pseudo' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.SALARIE_DATE_NAISSANCE], label: 'Date de naissance', placeholder: 'jj/mm/aaaa' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.SALARIE_NOM_NAISSANCE], label: 'Nom de naissance', placeholder: 'Nom' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.SALARIE_VILLE_NAISSANCE], label: 'Ville de naissance', placeholder: 'Ville' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.SALARIE_DEPARTEMENT_NAISSANCE], label: 'Département de naissance', placeholder: '01' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.SALARIE_NUMERO_SECU], label: 'N° sécu.', placeholder: '2 78 09 99 114 127 91' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.SALARIE_NUMERO_CONGE_SPEC], label: 'Numéro de congé spectacle', placeholder: 'B 068 8666' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.SALARIE_FISCALITE], label: 'Fiscalité', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.SALARIE_FISCALITE_LABEL], label: 'Fiscalité', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.SALARIE_STATUT_HANDICAP], label: 'Statut handicapé', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.SALARIE_STATUT_HANDICAP_LABEL], label: 'Statut handicapé', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.SALARIE_DATE_HANDICAP], label: 'Date d’acquisition du statut', placeholder: 'jj/mm/aaaa' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.SALARIE_ABATTEMENT], label: 'Déduction forfaitaire spécifique (DFS) pour frais professionnels', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.SALARIE_ABATTEMENT_LABEL], label: 'Déduction forfaitaire spécifique (DFS) pour frais professionnels', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.SALARIE_AVATAR], label: 'Image', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.SALARIE_IDENTIFIANT], label: 'Identifiant', placeholder: 'Adresse e-mail ou numéro téléphone' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.SALARIE_PROFIL], label: 'Masque du profil utilisateur', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.SALARIE_CLIENT98], label: 'Numéro de client CI-98', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.SALARIE_DIALOG98], label: 'Dialog migration CI-98', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.SALARIE_PRENOM], label: 'Prénom', placeholder: 'Prénom' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.SALARIE_NOM], label: 'Nom', placeholder: 'Nom' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.SALARIE_MAIL], label: 'Adresse mail', placeholder: 'E-mail' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.SALARIE_NUMERO], label: 'Téléphone', placeholder: '06 00 00 00 00' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.SYNCHRO98_IDENTIFIANT], label: 'Identifiant', placeholder: 'Adresse e-mail ou numéro téléphone' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.SYNCHRO98_PROFIL], label: 'Masque du profil utilisateur', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.SYNCHRO98_CLIENT98], label: 'Numéro de client CI-98', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.SYNCHRO98_DIALOG98], label: 'Dialog migration CI-98', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.SYNCHRO98_PRENOM], label: 'Prénom', placeholder: 'Prénom' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.SYNCHRO98_NOM], label: 'Nom', placeholder: 'Nom' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.SYNCHRO98_MAIL], label: 'Adresse mail', placeholder: 'E-mail' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.SYNCHRO98_NUMERO], label: 'Téléphone', placeholder: '06 00 00 00 00' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.ADRESSE_ADRESSE1], label: 'Adresse', placeholder: 'Numéro et rue' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.ADRESSE_ADRESSE2], label: 'Complément d\'adresse', placeholder: 'Batiment, étage...' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.ADRESSE_CODE_POSTAL], label: 'Code postal', placeholder: 'Ex : 78810' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.ADRESSE_VILLE], label: 'Ville', placeholder: 'Ex : Feucherolles' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.CONTACT_PRENOM], label: 'Prénom', placeholder: 'Prénom' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.CONTACT_NOM], label: 'Nom', placeholder: 'Nom' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.CONTACT_MAIL], label: 'Adresse mail', placeholder: 'E-mail' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.CONTACT_NUMERO], label: 'Téléphone', placeholder: '06 00 00 00 00' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.USER_IDENTIFIANT], label: 'Identifiant', placeholder: 'Adresse e-mail ou numéro téléphone' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.USER_PROFIL], label: 'Masque du profil utilisateur', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.USER_CLIENT98], label: 'Numéro de client CI-98', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.USER_DIALOG98], label: 'Dialog migration CI-98', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.USER_PRENOM], label: 'Prénom', placeholder: 'Prénom' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.USER_NOM], label: 'Nom', placeholder: 'Nom' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.USER_MAIL], label: 'Adresse mail', placeholder: 'E-mail' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.USER_NUMERO], label: 'Téléphone', placeholder: '06 00 00 00 00' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.DELIVERY_REFERENCE], label: 'Référence du bordereau', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.DELIVERY_AMOUNT], label: 'Montant', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.DELIVERY_COUNT], label: 'Nombre', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.TRANSACTION_REFERENCE], label: 'Référence', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.TRANSACTION_AMOUNT], label: 'Montant', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: GenControl[GenControl.RIB_IBAN], label: 'Code IBAN', placeholder: 'Ex : FR76 1111 2222 3333 4444 5555 666' },
];
